/** 佇列上限：超過就丟最舊的「非 sticky」那一筆，sticky 永遠不自動被丟。 */
export const NOTICE_CAP = 20;
/** 非 sticky 的存活時間（毫秒）。錯誤不在這張表裡＝永不自動消失。 */
export const NOTICE_TTL = {
    success: 6000,
    info: 9000,
    warning: 12000,
};
export function defaultSticky(kind) {
    return kind === 'error';
}
let seq = 0;
function nextId(now) {
    seq += 1;
    return `n${now.toString(36)}-${seq.toString(36)}`;
}
/**
 * 加一筆通知，回傳**新陣列**（不改傳入的）。
 *
 * - 同 `kind` + 同 `message` 已存在 → 只 `count + 1`、`at` 更新成現在、位置不動
 *   （重複的錯誤不會長出第二列，但也不會蓋掉別筆）。
 * - 否則 append 到最後（＝畫面最下面，最舊的在最上面：錯誤先被看到）。
 */
export function pushNotice(list, input, now = Date.now()) {
    const message = input.message.trim();
    if (message === '')
        return list.slice();
    const sticky = input.sticky ?? defaultSticky(input.kind);
    const existing = list.findIndex((item) => item.kind === input.kind && item.message === message);
    if (existing >= 0) {
        const next = list.slice();
        const prev = next[existing];
        next[existing] = {
            ...prev,
            at: now,
            count: prev.count + 1,
            sticky: prev.sticky || sticky,
            detail: input.detail ?? prev.detail ?? null,
            retry: input.retry ?? prev.retry ?? null,
        };
        return next;
    }
    const notice = {
        id: nextId(now),
        kind: input.kind,
        message,
        at: now,
        count: 1,
        sticky,
        detail: input.detail ?? null,
        retry: input.retry ?? null,
    };
    const next = [...list, notice];
    if (next.length <= NOTICE_CAP)
        return next;
    // 超量：從最舊開始丟，但 sticky（錯誤）優先保留。
    const overflow = next.length - NOTICE_CAP;
    let removed = 0;
    const kept = [];
    for (const item of next) {
        if (removed < overflow && !item.sticky) {
            removed += 1;
            continue;
        }
        kept.push(item);
    }
    return kept;
}
export function dismissNotice(list, id) {
    return list.filter((item) => item.id !== id);
}
/** 清掉某一類（重試成功後清掉舊錯誤用）。 */
export function clearNoticesOfKind(list, kind) {
    return list.filter((item) => item.kind !== kind);
}
/** 依 TTL 掃掉過期的非 sticky 通知；sticky 一律留著。 */
export function sweepNotices(list, now = Date.now()) {
    return list.filter((item) => {
        if (item.sticky || item.kind === 'error')
            return true;
        const ttl = NOTICE_TTL[item.kind] ?? 9000;
        return now - item.at < ttl;
    });
}
/** 畫面上的時間（`14:03:27`）；不用 Intl，避免執行環境 locale 差異。 */
export function noticeClock(at) {
    const d = new Date(at);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
export const NOTICE_KIND_LABEL = {
    error: '錯誤',
    warning: '警告',
    success: '成功',
    info: '提示',
};
//# sourceMappingURL=notices.js.map